import { isNil } from 'lodash-es'

export default function isNotNil<T>(v?: Maybe<T>): v is T {
  return !isNil(v)
}
